import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EMPLOYER } from 'constants/index';
import { SortValue, TypeValue } from 'types/jobPosts';
import { getAllJobPosts } from '../actions';

const getOrder = (sortValue: SortValue) => {
  switch (sortValue) {
    case 'Newest':
      return { order: ['createdAt DESC'] };
    case 'Oldest':
      return { order: ['createdAt ASC'] };
    case 'A - Z':
      return { order: ['title DESC'] };
    default:
      return {};
  }
};

const getTypeFilter = (typeValue: TypeValue) => {
  switch (typeValue) {
    case 'Permanent':
      return { type: 'Permanent' };
    case 'Part time':
      return { type: 'Part time' };
    default:
      return {};
  }
};

const useSorting = () => {
  const { role } = useSelector<any, any>(state => state.user);
  const [sortValue, setSortValue] = useState('Newest');
  const [typeValue, setTypeValue] = useState('All');
  const dispatch = useDispatch();

  useEffect(() => {
    if (role !== EMPLOYER) {
      dispatch(
        getAllJobPosts(
          JSON.stringify({
            where: {
              ...getTypeFilter(typeValue as TypeValue),
              status: 'active',
            },
            ...getOrder(sortValue as SortValue),
          })
        )
      );
    }
  }, [dispatch, sortValue, typeValue, role]);

  return {
    sortValue,
    setSortValue,
    typeValue,
    setTypeValue,
  };
};

export default useSorting;
